import React from 'react'
import clsx from "clsx"
import DataTable from "../../DataTable/DataTable"

//import I18n from "i18n-js/index.js.erb"

export default class RoomTypePresenterPrice extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'price',
      'tab-pane': true
    })
    // var days_of_week = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
    // var days = days_of_week.map((day_of_week) => this.renderDayOfWeek(day_of_week))
    // var base_price = days_of_week.map((day_of_week) => this.renderBasePrice(day_of_week))
    // var min_stay = days_of_week.map((day_of_week) => this.renderDailyMinimumStay(day_of_week))

    return (
    
      <div className={tabClasses} id="price">
        <DataTable endpoint={this.props.room_type_prices_data_table_path}  
          date_format={this.props.date_format} 
          time_format={this.props.time_format} 
          no_data_text={I18n.t('none')} 
          currency_unit={I18n.t('number.currency.format.unit')}
          delimiter={I18n.t('number.currency.format.delimiter')}
          separator={I18n.t('number.currency.format.separator')}
          read_only={true}
        />

      </div>
    )
  }





}